import React from 'react';
import { Calendar, MessageCircle } from 'lucide-react';

const WHATSAPP_NUMBER = '491796674356';
const WHATSAPP_DISPLAY = '+49 179 6674356';
const WHATSAPP_MESSAGE = encodeURIComponent(
  'Hallo Saale Lounge, ich möchte gerne einen Tisch reservieren.'
);
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_MESSAGE}`;

const ReservationSection = () => {
  const handleWhatsAppClick = (e) => {
    e.preventDefault();
    const win = window.open(WHATSAPP_URL, '_blank', 'noopener,noreferrer');
    if (!win || win.closed || typeof win.closed === 'undefined') {
      try {
        window.top.location.href = WHATSAPP_URL;
      } catch {
        window.location.href = WHATSAPP_URL;
      }
    }
  };

  return (
    <section
      id="reservation"
      className="py-20 px-4"
      style={{ background: 'linear-gradient(to bottom, #1A0520, #0A0015)' }}
      data-testid="reservation-section"
    >
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12 animate-fade-in-up">
          <Calendar
            className="w-12 h-12 mx-auto mb-4 text-neon-pink animate-icon-pulse"
            style={{ filter: 'drop-shadow(0 0 10px #FF00FF)' }}
          />
          <h2
            className="text-4xl md:text-5xl font-bold text-white mb-4"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Tisch Reservieren
          </h2>
          <div className="h-1 w-24 bg-gradient-to-r from-neon-pink to-deep-violet mx-auto rounded-full mb-6" />
          <p
            className="text-2xl font-bold"
            style={{
              fontFamily: "'Playfair Display', serif",
              color: '#FF00FF',
              textShadow: '0 0 15px #FF00FF, 0 0 30px #FF00FF, 0 0 45px #FF00FF',
            }}
          >
            Sichere dir deinen Platz in der Saale Lounge
          </p>
        </div>

        <div className="text-center animate-fade-in-up delay-200">
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleWhatsAppClick}
            data-testid="whatsapp-reservation-btn"
            className="inline-flex items-center gap-3 px-8 py-5 rounded-full font-semibold text-lg md:text-xl transition-all duration-300 hover:scale-105"
            style={{
              background: 'linear-gradient(135deg, #25D366 0%, #128C7E 100%)',
              color: '#fff',
              boxShadow:
                '0 0 25px rgba(37, 211, 102, 0.6), 0 0 50px rgba(37, 211, 102, 0.3)',
              fontFamily: "'Playfair Display', serif",
            }}
          >
            <MessageCircle className="w-6 h-6" />
            Jetzt Tisch reservieren per WhatsApp
          </a>

          <p
            className="mt-6 text-white/70 text-base md:text-lg"
            data-testid="whatsapp-number"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            {WHATSAPP_DISPLAY}
          </p>
        </div>
      </div>
    </section>
  );
};

export default ReservationSection;
